import {UserProfileState} from "@/vuex/modules/profile-module/state";
import {GetterTree} from "vuex";
import {RootState} from "@/vuex/store";

const getters: GetterTree<UserProfileState, RootState> = {}

export default getters;